module.exports = __webpack_public_path__ + "static/img/cj02.78a2799.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/cj02.png
// module id = 146
// module chunks = 0